module.exports = __webpack_public_path__ + "img/gallery-5.e2c58952.jpg";